/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.privacy.center.rpc.DprPublicRpc
 */
import * as References from './DprPublicRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.privacy.center.rpc.DprPublicRpc#getConfigurationBySlug
 */
export const GET_CONFIGURATION_BY_SLUG_MUTATION_FIELD_NAME = 'com_hubspot_privacy_center_rpc_DprPublicRpc_getConfigurationBySlug';
export const GET_CONFIGURATION_BY_SLUG_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: GET_CONFIGURATION_BY_SLUG_MUTATION_FIELD_NAME,
  args: ['slug'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getConfigurationBySlugRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.privacy.center.rpc.DprPublicRpc#verifyToken
 */
export const VERIFY_TOKEN_MUTATION_FIELD_NAME = 'com_hubspot_privacy_center_rpc_DprPublicRpc_verifyToken';
export const VERIFY_TOKEN_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: VERIFY_TOKEN_MUTATION_FIELD_NAME,
  args: ['token'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.verifyTokenRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.privacy.center.rpc.DprPublicRpc#submitDprRequest
 */
export const SUBMIT_DPR_REQUEST_MUTATION_FIELD_NAME = 'com_hubspot_privacy_center_rpc_DprPublicRpc_submitDprRequest';
export const SUBMIT_DPR_REQUEST_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SUBMIT_DPR_REQUEST_MUTATION_FIELD_NAME,
  args: ['slug', 'requestType', 'locale', 'country', 'email', 'recaptchaToken', 'userAgent'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.submitDprRequestRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.privacy.center.rpc.DprPublicRpc#requestContactExport
 */
export const REQUEST_CONTACT_EXPORT_MUTATION_FIELD_NAME = 'com_hubspot_privacy_center_rpc_DprPublicRpc_requestContactExport';
export const REQUEST_CONTACT_EXPORT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REQUEST_CONTACT_EXPORT_MUTATION_FIELD_NAME,
  args: ['token'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.requestContactExportRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.privacy.center.rpc.DprPublicRpc#requestContactDeletionToken
 */
export const REQUEST_CONTACT_DELETION_TOKEN_MUTATION_FIELD_NAME = 'com_hubspot_privacy_center_rpc_DprPublicRpc_requestContactDeletionToken';
export const REQUEST_CONTACT_DELETION_TOKEN_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REQUEST_CONTACT_DELETION_TOKEN_MUTATION_FIELD_NAME,
  args: ['token', 'userAgent'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.requestContactDeletionTokenRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.privacy.center.rpc.DprPublicRpc#confirmContactDeletion
 */
export const CONFIRM_CONTACT_DELETION_MUTATION_FIELD_NAME = 'com_hubspot_privacy_center_rpc_DprPublicRpc_confirmContactDeletion';
export const CONFIRM_CONTACT_DELETION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CONFIRM_CONTACT_DELETION_MUTATION_FIELD_NAME,
  args: ['token'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.confirmContactDeletionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});